import React from 'react';
import Layout from '../components/Layout';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '🏠',
      title: 'Greenhouse Installation',
      description: 'Professional setup and installation of greenhouse structures with expert guidance and support.',
      features: [
        'Custom design and planning',
        'Professional installation',
        'Post-installation support',
        'Maintenance guidance'
      ]
    },
    {
      id: 2,
      icon: '🛡️',
      title: 'Pest Control Services',
      description: 'Comprehensive pest management solutions to protect your crops and ensure healthy growth.',
      features: [
        'Expert consultation',
        'Eco-friendly solutions',
        'Regular monitoring',
        'Preventive measures'
      ]
    },
    {
      id: 3,
      icon: '🚚',
      title: 'Delivery Service',
      description: 'Fast and reliable delivery of agricultural products across Nigeria.',
      features: [
        'Nationwide coverage',
        'Fast delivery times',
        'Secure packaging',
        'Tracking available'
      ]
    },
    {
      id: 4,
      icon: '💡',
      title: 'Consultation Services',
      description: 'Expert advice on farming practices, crop selection, and agricultural best practices.',
      features: [
        'Farm assessment',
        'Custom recommendations',
        'Best practices guidance',
        'Ongoing support'
      ]
    },
    {
      id: 5,
      icon: '🔧',
      title: 'Maintenance & Support',
      description: 'Regular maintenance and technical support for all your agricultural equipment.',
      features: [
        'Scheduled maintenance',
        'Emergency repairs',
        'Technical support',
        'Equipment training'
      ]
    },
    {
      id: 6,
      icon: '📚',
      title: 'Training Programs',
      description: 'Educational programs and workshops to enhance your farming knowledge and skills.',
      features: [
        'Hands-on training',
        'Expert instructors',
        'Practical workshops',
        'Certification programs'
      ]
    }
  ];

  return (
    <Layout>
      <div className="services-page">
        <div className="services-hero">
          <div className="services-hero-content">
            <h1>Our Services</h1>
            <p>Comprehensive Agricultural Solutions for Modern Farming</p>
          </div>
        </div>

        <div className="services-content">
          <div className="services-container">
            <div className="services-grid">
              {services.map(service => (
                <div key={service.id} className="service-card">
                  <div className="service-icon-large">{service.icon}</div>
                  <h2>{service.title}</h2>
                  <p className="service-description">{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  <button className="service-btn">Learn More</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Services;
